/**
 * @author LiZiAo
 * @date 2022-12-12
 * @Description: 精准复习路由
 */
export default {
  path: "/review",
  name: "preciseReview",
  component: () => import("@/components/preciseReview/index.vue"),
  redirect: "/review/home",
  meta: {
    type: "3",
    title: "首页"
  },
  children: [
    {
      path: "home",
      name: "preciseReviewHome",
      component: () => import("@/components/preciseReview/home/index.vue"),
      meta: {
        breadcrumb: false
      }
    },
    {
      path: "personal",
      name: "ReviewPersonal",
      component: () => import("@/components/preciseReview/home/index.vue"),
      meta: {
        title: "个人详情",
        key: true // 设置key为true，当跳到该路由的时候需要强制重新加载组件。
      }
    },
    /**
     * 自学详情
     */
    {
      path: "studyCourseDetail",
      name: "StudyCourseDetail",
      component: () => import("@/components/preciseReview/home/studyCourseDetail.vue"),
      meta: {
        title: "自学详情",
        key: true // 设置key为true，当跳到该路由的时候需要强制重新加载组件。
      }
    },
    /*
      ----------------------------------------------------------------测验管理*/
    {
      path: "evaluation",
      name: "Evaluation",
      component: () => import("@/components/common/parent.vue"),
      meta: { title: "测验管理" },
      redirect: "/review/evaluation/home",
      children: [
        {
          path: "home",
          name: "EvaluationHome",
          component: () =>
            import("@/components/preciseReview/evaluationManagement/index.vue"),
          meta: { keepAlive: true, level: 3 },
          beforeEnter(to, from, next) {
            // 如果是从特定页面进入那么所有条件应该重置
            if (
              from.path === "/review/evaluation" ||
              from.path === "/review/evaluation/manuallyPaper" ||
              from.path === "/review/evaluation/autoPaper"
            ) {
              to.params.clear = true;
              to.params.componentName = "evaluationManagementIndex";
            }
            next();
          }
        },
        {
          path: "manuallyPaper",
          name: "EvaluationManuallyPaper",
          meta: { title: "手动组卷" },
          component: () =>
            import(
              "@/components/preciseReview/evaluationManagement/manuallyPaper.vue"
            )
        },
        {
          path: "autoPaper",
          name: "autoPaper",
          meta: { title: "自动组卷" },
          component: () =>
            import(
              "@/components/preciseReview/evaluationManagement/autoPaper/index.vue"
            )
        },
        {
          // 查阅
          path: "testPaperConsult",
          name: "teacherEvaluationConsult",
          component: () => import("@/components/common/parent.vue"),
          redirect: "/review/evaluation/testPaperConsult/index",
          beforeEnter(to, from, next) {
            const currentRoute = to.matched.find(
              item => item.name === "teacherEvaluationConsult"
            );
            currentRoute.meta.title = to.query.paperName + " · 测评报告";
            next();
          },
          children: [
            {
              path: "index",
              name: "teacherEvaluationConsultIndex",
              component: () =>
                import(
                  "@/components/preciseReview/evaluationManagement/consultIndex.vue"
                )
            },
            {
              path: "teatPaperStudentConsult",
              name: "teacherEvaluationStudentConsult",
              component: () =>
                import(
                  "@/components/preciseReview/evaluationManagement/studentConsultIndex.vue"
                )
            },
            {
              path: "teacherEvaluationStudentReview",
              name: "teacherEvaluationStudentReview",
              component: () =>
                import(
                  "@/components/preciseReview/evaluationManagement/studentReviewIndex.vue"
                )
            }
          ]
        },
        {
          // 批阅
          path: "teacherEvaluationReview",
          name: "teacherEvaluationReview",
          component: () =>
            import(
              "@/components/preciseReview/evaluationManagement/reviewIndex.vue"
            )
        }
      ]
    },
    /*
      ----------------------------------------------------------------班级管理*/
    {
      path: "classManagement",
      name: "ClassManagement",
      component: () => import("@/components/common/parent.vue"),
      meta: {
        title: "班级管理"
      },
      redirect: "/review/classManagement/home",
      children: [
        {
          path: "home",
          name: "ClassManagementHome",
          component: () =>
            import("@/components/preciseReview/classManagement/index.vue"),
          meta: { keepAlive: true, level: 3 },
          beforeEnter(to, from, next) {
            // 如果是从特定页面进入那么所有条件应该重置
            if (from.path === "/review/classManagement") {
              to.params.clear = true;
              to.params.componentName = "ClassManagementHome";
            }
            next();
          }
        },
        {
          path: "details",
          name: "ClassDetails",
          component: () =>
            import(
              "@/components/preciseReview/classManagement/classDetails.vue"
            )
        }
      ]
    },
    /*
      ----------------------------------------------------------------班级管理*/
    {
      path: "dataAnalysis",
      name: "DataAnalysis",
      component: () => import("@/components/common/parent.vue"),
      meta: {
        title: "数据分析"
      },
      redirect: "/review/dataAnalysis/home",
      children: [
        {
          path: "home",
          name: "DataAnalysisHome",
          component: () =>
            import("@/components/preciseReview/dataAnalysis/index.vue")
        }
      ]
    },
    /*
         ----------------------------------------------------------------题库管理*/
    {
      path: "bank",
      name: "Bank",
      component: () => import("@/components/common/parent.vue"),
      meta: {
        title: "题库管理"
      },
      redirect: "/review/bank/home",
      children: [
        {
          path: "home",
          name: "BankHome",
          meta: {
            back: "/review/home",
            keepAlive: true,
            level: 3
          },
          component: () =>
            import("@/components/preciseReview/bankManagement/index.vue"),
          beforeEnter(to, from, next) {
            // 如果是从特定页面进入那么所有条件应该重置
            if (
              from.path === "/review/bank" ||
              from.path === "/review/evaluation/manuallyPaper"
            ) {
              to.params.clear = true;
              to.params.componentName = "BankHome";
            }
            next();
          }
        },
        {
          path: "bankView",
          name: "BankView",
          component: () =>
            import(
              "@/components/preciseReview/bankManagement/exerBankView.vue"
            ),
          meta: { keepAlive: true, level: 1 },
          beforeEnter(to, from, next) {
            // 如果是从特定页面进入那么所有条件应该重置
            if (
              from.path === "/review/bank/home" ||
              from.meta.isCreate === true
            ) {
              to.params.clear = true;
              to.params.componentName = "teacherExerBankView";
            }
            next();
          }
        },
        // 试题篮
        {
          path: "exerBank/exerBasket",
          name: "teacherExerBasket",
          component: () => import("@/components/tarAdmin/common/exerBasket.vue")
        },
        // 编辑/新增题库
        {
          path: "exerAdd",
          name: "teacherExerAddCommon",
          component: () =>
            import("@/components/tarAdmin/common/exerAddCommon.vue")
        }
      ]
    }
  ]
};



// WEBPACK FOOTER //
// ./src/router/modules/preciseReview.js